import React from 'react';
import clsx from 'clsx';
import { Radio } from '@material-ui/core';
import { NameTextField } from '../../../../../../styling/Styles';
import DropdownMechanism from '../../../../../GeneralComponents/DropdownMechanism';
import TransitionByIdCheckbox from './TransitionByIdCheckbox';
import NewWindowCheckbox from './NewWindowCheckbox';
 
const ErrorDisplayMessage = (props) => {
    
    const {
        condition,
        text
    } = props;
    
    return(
        <span
            className={clsx('MuiFormHelperText-root', 'Mui-error')}
            style={
                condition
                ? { display: 'inherit' }
                : { display: 'none' }
            }
        >   
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
            { condition ? text : '' }
        </span>
    )
}

const RadioMechanism = (props) => {

    const {
        editor,
        hrefChecked,
        handleHref,
        href,
        targetPageChecked,
        target,
        targets,
        selectTarget,
        previousPageChecked,
        handleRadioChecked,
        insertCustomCodeChecked,
        transitionById,
        handleTransitionByIdChecked,
        newWindowChecked,
        handleNewWindowChecked
    } = props;

    const openEditor = () => {
        const commands = editor.Commands;
        handleRadioChecked(insertCustomCodeChecked,'insertCode');
        document.getElementById('editDataElementPopUp').style.visibility = 'hidden';
        commands.run("handleInsertCodePanel");
    }


    return(
        <>  
            <div className={clsx('spacingTopDiv', 'teamSelector')} aria-hidden="true" onClick={() => handleRadioChecked(hrefChecked,'href')} >
                
                <Radio checked={hrefChecked} style={{color: '#0c4d82',padding: '0px'}} inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                &nbsp; Go to url: &nbsp; <span style={{display: 'inline-block', marginLeft: '4vw' }}>&nbsp;</span>
                <div style={{display: 'inline-flex', paddingTop: '0.5vw'}}>
                    <NameTextField
                        id='urlNameInput'
                        placeholder=' Url name'
                        onInput={e =>handleHref(e)}
                        value={href}
                    />
                </div>
                <ErrorDisplayMessage
                    condition={hrefChecked === true && href===''}
                    text='defined url empty'
                />
                { hrefChecked === true && href !== '' &&
                    <NewWindowCheckbox
                        newWindowChecked={newWindowChecked}
                        handleNewWindowChecked={handleNewWindowChecked}
                    />
                }

            </div>
            <div 
                className={clsx('teamSelector', 'spacingTopDiv')} 
                onClick={ () => handleRadioChecked(previousPageChecked,'previousPage')}
                aria-hidden="true"
            >
                <Radio checked={previousPageChecked} style={{color: '#0c4d82',padding: '0px'}}  inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                    &nbsp; 
                <span> Go to previous page &nbsp;</span>
            </div>  
            <div 
                className={clsx('teamSelector', 'spacingTopDiv')} 
                onClick={() => {handleRadioChecked(targetPageChecked,'targetPage')}}
                aria-hidden="true"
            >
                    <Radio checked={targetPageChecked} style={{color: '#0c4d82',padding: '0px'}}  inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                        &nbsp; 
                    <span> Go to project page: &nbsp;
                        <DropdownMechanism
                            target = {target}
                            targets={targets}
                            selectTarget={selectTarget}
                        />
                    </span>
                    <ErrorDisplayMessage
                        condition={targetPageChecked === true && target==='none'}
                        text='defined target page none'
                    />
            </div> 
            <TransitionByIdCheckbox
                transitionById={transitionById}
                handleTransitionByIdChecked={handleTransitionByIdChecked}
                targetPageChecked={targetPageChecked}
                target={target}
            />
            { targetPageChecked === true && target !== 'none' &&
                <NewWindowCheckbox
                    newWindowChecked={newWindowChecked}
                    handleNewWindowChecked={handleNewWindowChecked}
                />
            }
            <div 
                className={clsx('spacingTopDiv')} 
                style={{display: 'flex'}}
                >
                    <div 
                        className={clsx('teamSelector')}
                        onClick={() => {handleRadioChecked(insertCustomCodeChecked,'insertCode')}}
                        aria-hidden="true"
                    >
                        <Radio checked={insertCustomCodeChecked} style={{color: '#0c4d82',padding: '0px'}}  inputProps={{ 'aria-label': 'uncontrolled-checkbox' }} />
                            &nbsp; 
                        <span> Insert custom js code: &nbsp; </span>
                    </div>

                    <span aria-hidden="true" onClick={() => openEditor()} className={clsx('openEditorStyle')}> Open editor</span>

                    
            </div> 
        </>
    )

}

export default RadioMechanism;